var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function newPortalSettings(data) {
    var instance = {
        __type: "PortalSettings:#DecisionsFramework.ServiceLayer.Services.Portal",
        LogToConsoleLevel: 0 /* ClientLogLevel.Unknown */,
        LogToServerLevel: 0 /* ClientLogLevel.Unknown */,
        ProcessViewPage: null,
        ProcessViewPageName: null,
        SubProcessViewPage: null,
        ProcessViewPageWithParentProcessLink: null,
        SubProcessViewPageWithParentProcessLink: null,
        MinPortalWidth: 0,
        MinPortalHeight: 0,
        ActionLocation: 0 /* MainActionLocation.Both */,
        ShowFoldersInSubMenu: false,
        DefaultLanguage: null,
        DefaultLanguageCode: null,
        Translation: 0 /* TranslateStrings.No */,
        ShowSettingsInHeader: false,
        ShowAccountInHeader: false,
        ShowAboutInHeader: false,
        ShowLockInHeader: false,
        ShowLogoutInHeader: false,
        UserSessionLength: "00:00:00",
        EnableGuestAccount: false,
        LockPortalShortcut: null,
        ConfirmPortalLeaving: false,
        PortalSize: null,
        Theme: null,
        RememberUserUiSetup: false,
        UseBrowserZoom: false,
        FolderSearchResultLimit: 0,
        InlineSearchResultLimit: 0,
        DisableTextSearch: false,
        ShowDevelopmentActions: false,
        Logo: null,
        ShowLogoInHeader: false,
        Favicon: null,
        DifferentLoginLogo: false,
        LoginLogo: null,
        SloganText: null,
        ShowCurrentFolderNameInHeader: false,
        ShowInstanceName: 0 /* InstanceNameVisibility.MultiTenant */,
        MaxRecentItems: 0,
        ShowServiceCatalogNode: false,
        ShowAcctImpersonationAction: false,
        ShowLockPortalAction: false,
        ShowSubmitFeedback: false,
        SubmitFeedbackAddress: null,
        CollapsedTreeOnStartStudio: false,
        CollapsedTreeOnStartUserPortal: false,
        ServiceCatalogNodeName: null,
        ShowMyDesignsNode: false,
        MyDesignsNodeName: null,
        ShowDashboardsNode: false,
        ShowDetailLinkOnErrorDialog: false,
        ShowDeveloperLevelErrors: false,
        FormSessionNotFoundErrorMessage: null,
        ShowKnowledgeBaseNode: false,
        KnowledgeBaseNodeName: null,
        ShowHomeFolder: false,
        MyTasksNodeName: null,
        ShowFavoritesNode: false,
        ShowRecentNode: false,
        DefaultEmailAddress: null,
        NewUserDefaultGroups: null,
        ShowNewUserWelcomeWizard: null,
        DoNotAutoGenerateThemeCss: false,
        SecurityQuestionForAccount: null,
        DefaultWebPageTitle: null,
        InferWebPageTitleFromUrl: false,
        StorePasswordInRecoverableWay: false,
        HideRememberMe: false,
        TermsOfServices: null,
        InstanceDefaultTimeZone: null,
        DefaultExportSubEntitiesOption: 0 /* ExportSubEntitiesOptions.Include */,
        AssignTaskWhenImportingMissingFolder: false,
        SecureContactsInReadonlyMode: false,
        SecureContactsInEditMode: false,
        AllowAutoAdd: false,
        ShowContactOrder: false,
        IncludeAddressesInContactView: false,
        AllowSelfRegisterUsers: false,
        CustomSelfRegistrationURL: null,
        RegisteredUsersMustConfirm: false,
        EmailConfirmationFlowId: null,
        ConfirmationPageLocation: null,
        ShowInviteAction: false,
        SendNotificationsFromSystemAccount: false,
        AllowUsersToOptOutOfNotifications: false,
        TurnOffNotifyToMe: false,
        NotifyReportStructureChange: false,
        NotificationTimeout: "00:00:00",
        NotificationItemsTimeout: "00:00:00",
        HelpURL: null,
        ContactUsURL: null,
        NewsFeed: null,
        HideForgotPasswordLink: false,
        HideGetHelpLink: false,
        HideContactUsLink: false,
        EnableustomMaintenanceModeMessage: false,
        CustomMaintenanceModeMessage: null,
        HandlePasswordResetCommunicationViaFlow: false,
        PasswordResetCommunicationFlowId: null,
        DefaultFolderId: null,
        ShowDefaultPage: false,
        NavigateDefaultPageId: null,
        NavigateDefaultHTMLPageId: null,
        DefaultMobileViewPageId: null,
        NavigateDefaultPageName: null,
        ShowBrowseView: false,
        BrowsePageName: null,
        ShowBrowsePageToAdministrators: false,
        ShowDefaultPageIfUserPageSpecified: false,
        ShowDefaultPageIfSystemPageSpecified: false,
        DefaultGroups: null,
        GroupAccountLimit: 0,
        ShowCreateRootFolder: false,
        AnyUserCreateRootFolder: false,
        GroupsAllowedToCreateRootFolder: null,
        InstanceDefaultCulture: null,
        TimeFormat: 0 /* TimeFormats.Default */,
        DateFormat: 0 /* DateFormats.Default */,
        NumberFormatSource: 0 /* NumberFormatSource.UseCultureDefault */,
        DefaultNumberDecimalDigits: 0,
        UseNumberGroupSeparator: false,
        NumberGroupSeparator: null,
        UseExtensionsAllowed: false,
        ExtensionsNotAllowed: null,
        ExtensionsAllowed: null,
        AllowMultipleFileExtentions: false,
        MinPasswordChars: 0,
        IsUpperLowerCase: false,
        IsSymbole: false,
        IsNumber: false,
        IsAccountExpirationEnabled: false,
        PasswordExpiresDays: 0,
        IsLockoutEnabled: false,
        NumberOfAttempts: 0,
        ForceSessionCloseOnPasswordChange: false,
        CompareLastFourPasswords: false,
        SilverPartBaseHasDarkTheme: false,
        SilverPartBaseHasShadow: false,
        SilverPartBaseHideActionMenu: false,
        SilverPartBaseHideHeader: false,
        SilverPartBaseSmallTitle: false,
        SilverPartBaseShowActionsOnHeader: false,
        SilverPartBaseShowActionsAsIcons: false,
        SilverPartBaseIsClosable: false,
        SilverPartBaseIsCollapsable: false,
        SilverPartBaseHasBorder: false,
        SilverPartBaseIsTransparent: false,
        SilverPartContainerHasDarkTheme: false,
        SilverPartContainerHasShadow: false,
        SilverPartContainerHideActionMenu: false,
        SilverPartContainerHideHeader: false,
        SilverPartContainerSmallTitle: false,
        SilverPartContainerShowActionsOnHeader: false,
        SilverPartContainerShowActionsAsIcons: false,
        SilverPartContainerIsClosable: false,
        SilverPartContainerIsCollapsable: false,
        SilverPartContainerHasBorder: false,
        SilverPartContainerIsTransparent: false,
        SilverPartChildHasDarkTheme: false,
        SilverPartChildHasShadow: false,
        SilverPartChildHideActionMenu: false,
        SilverPartChildHideHeader: false,
        SilverPartChildSmallTitle: false,
        SilverPartChildShowActionsOnHeader: false,
        SilverPartChildShowActionsAsIcons: false,
        SilverPartChildIsClosable: false,
        SilverPartChildIsCollapsable: false,
        SilverPartChildHasBorder: false,
        SilverPartChildIsTransparent: false,
        SilverPartChromelessHasDarkTheme: false,
        SilverPartChromelessHasShadow: false,
        SilverPartChromelessHideActionMenu: false,
        SilverPartChromelessHideHeader: false,
        SilverPartChromelessSmallTitle: false,
        SilverPartChromelessShowActionsOnHeader: false,
        SilverPartChromelessShowActionsAsIcons: false,
        SilverPartChromelessIsClosable: false,
        SilverPartChromelessIsCollapsable: false,
        SilverPartChromelessHasBorder: false,
        SilverPartChromelessIsTransparent: false,
        SilverPartBaseHorizontalMarginAtBorder: 0,
        SilverPartBaseVerticalMarginAtBorder: 0,
        SilverPartBaseHorizontalMarginInside: 0,
        SilverPartBaseVerticalMarginInside: 0,
        SilverPartContainerHorizontalMarginAtBorder: 0,
        SilverPartContainerVerticalMarginAtBorder: 0,
        SilverPartContainerHorizontalMarginInside: 0,
        SilverPartContainerVerticalMarginInside: 0,
        SilverPartChildHorizontalMarginAtBorder: 0,
        SilverPartChildVerticalMarginAtBorder: 0,
        SilverPartChildHorizontalMarginInside: 0,
        SilverPartChildVerticalMarginInside: 0,
        SilverPartChromelessHorizontalMarginAtBorder: 0,
        SilverPartChromelessVerticalMarginAtBorder: 0,
        SilverPartChromelessHorizontalMarginInside: 0,
        SilverPartChromelessVerticalMarginInside: 0,
        AutoSubmitEditorValue: false,
        AutoSubmitEditorOnFirstType: false,
        AutoSubmitEditorOnClear: false,
        AutoSubmitInterval: 0,
        DefaultEditorWidth: 0,
        DefaultEditorHeight: 0,
        ShowSuggestionInDateEditor: false,
        SsoEnabled: false,
        AutoLockScreen: false,
        AutoLockOnLogoutDelay: "00:00:00",
        AutoLockTimeout: "00:00:00",
        AutoLockReloginAppearance: 0 /* AutoLockReloginAppearance.ShowUserNameAsLabel */,
        ShowSpinnerForFlowRuntime: false,
        ProductTitle: null,
        ShowConfirmationDialog: false,
        ShowReportHeaderAsToolbar: false,
        ReportAutoPagingThreshold: 0,
        DefaultPrintTemplateId: null,
        NewWindowStyle: 0 /* ChromeSetting.None */,
        ShowFavorites: false,
        ShowFoldersCatalog: false,
        ShowRecentFolder: false,
        UseDefaultIconsInFolderTree: false,
        HideTopBarSearch: false,
        PortalSideBarDefaultPanel: 0 /* PortalSideBarDefaultPanel.Folders */,
        HideWorkflowCatalog: false,
        StartWorkflowTitle: null,
        RootWorkflowCatalogItems: null,
        LoginUserFlowId: null,
        RestrictSimultaneousLogins: false,
        LoginUserUIFlowId: null,
        UseMobilePortalonTablet: false,
        LockSessionToIPAddress: false,
        IsTwoFactorAuthenticationEnabled: false,
        TwoFactorAuthenticationTokenType: 0 /* TwoFactorAuthenticationType.Numeric */,
        TwoFactorAuthenticationTokenLength: 0,
        TwoFactorAuthenticationTimeout: 0,
        FolderTimelineMaxStatesBeforeForcedExpand: 0,
        UserBackAccountKey: null,
        ResetPasswordLinkLifeSpan: 0,
        Id: null,
        Hidden: false,
        AdministratorViewOnly: false,
        EntityFolderID: null,
        HistoryFolderID: null,
        AllTagsData: null,
        State: null,
        CreatedOnDate: new Date('0001-01-01T00:00:00Z'),
        ModifiedDate: new Date('0001-01-01T00:00:00Z'),
        CreatedBy: null,
        ModifiedBy: null,
        Archived: false,
        ArchivedBy: null,
        ArchivedDate: new Date('0001-01-01T00:00:00Z'),
        Deleted: false,
        DeletedBy: null,
        DeletedOn: new Date('0001-01-01T00:00:00Z'),
        CustomLongDescription: null,
        CustomShortDescription: null
    };
    return __assign(__assign({}, instance), data);
}
export function isPortalSettings(object) {
    return object.__type === "PortalSettings:#DecisionsFramework.ServiceLayer.Services.Portal";
}
